// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface FontIconSignature {
  Element: SVGSVGElement;
}

export const FontIcon: TOC<FontIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path d="M19 2H5C4.448 2 4 2.448 4 3V6H6V4H11V20H8V22H16V20H13V4H18V6H20V3C20 2.448 19.552 2 19 2Z"/>
</svg>
</template>;